import { Row, VirtualGiftSection as VirtualGiftSectionProps } from '@web/graphql-components'
import { VirtualGiftSection as PageVirtualGiftSection } from '@web/components/page-components/VirtualGiftSection'
import PageComponent from '../PageComponent'
import VirtualGiftSectionHandler from './VirtualGiftSectionHandler'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { usePathname } from 'next/navigation'
import VirtualGiftMatchedGivingBanner from './VirtualGiftMatchedGivingBanner'
import { censorGiftText } from 'apps/fe-donation/libs/censorGiftText'
import { useCallback, useEffect, useRef, useState } from 'react'

const VirtualGiftSection = (props: VirtualGiftSectionProps & Row) => {
  const pathname = usePathname()
  const isThankYouPage = usePageStore((state) => state.isThankYouPage) || pathname.endsWith('thanks')
  const ref = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState(false)
  const censorInput = useCallback((input: string) => censorGiftText(input), [])

  useEffect(() => {
    if (ref.current) {
      setIsVisible(ref.current.offsetParent !== null)
    }
  }, [])

  return (
    <PageVirtualGiftSection
      {...props}
      Component={PageComponent}
      isThankYouStep={isThankYouPage}
      censorInput={censorInput}
    >
      {!isThankYouPage && <VirtualGiftSectionHandler />}
      <div ref={ref}>{isVisible && !isThankYouPage && <VirtualGiftMatchedGivingBanner />}</div>
    </PageVirtualGiftSection>
  )
}

export default VirtualGiftSection
